module.exports = __webpack_public_path__ + "intro-banner-02.1ab35c343121f5dc1ff0.jpg";


//////////////////
// WEBPACK FOOTER
// D:/sachin/umc-new/umc/src/assets/images/intro-banner-02.jpg
// module id = ../../../../../src/assets/images/intro-banner-02.jpg
// module chunks = styles